(() => {
  let refreshing = false;
  async function refreshRelease() {
    if (document.hidden || refreshing || window.Shopify?.designMode) return;
    refreshing = true;
    try {
      const cardSections = new Set([...document.querySelectorAll('[data-grs-stock-card]')].map(card => card.closest('[id^="shopify-section-"]')).filter(Boolean));
      for (const section of cardSections) {
        const cardUrl = new URL(window.location.href);
        cardUrl.searchParams.set('section_id', section.id.replace('shopify-section-', ''));
        const response = await fetch(cardUrl, {cache: 'no-store', signal: AbortSignal.timeout(10000)});
        if (!response.ok) continue;
        const nextSection = new DOMParser().parseFromString(await response.text(), 'text/html');
        section.querySelectorAll('[data-grs-stock-card]').forEach(card => {
          const updated = [...nextSection.querySelectorAll('[data-grs-stock-card]')].find(next => next.dataset.grsStockCard === card.dataset.grsStockCard);
          if (updated && updated.textContent !== card.textContent) card.replaceWith(updated);
        });
      }
      const root = document.querySelector('[data-grs-stock-section]');
      if (!root || root.contains(document.activeElement)) return;
      const url = new URL(window.location.href);
      url.searchParams.set('section_id', root.dataset.grsStockSection);
      const response = await fetch(url, {cache: 'no-store', signal: AbortSignal.timeout(10000)});
      if (!response.ok) return;
      const next = new DOMParser().parseFromString(await response.text(), 'text/html').querySelector('[data-grs-stock-section]');
      if (!next || next.dataset.grsStockVersion === root.dataset.grsStockVersion) return;
      const openDetails = [...root.querySelectorAll('details')].map(el => el.open);
      root.replaceWith(next);
      next.querySelectorAll('details').forEach((el, index) => { el.open = !!openDetails[index]; });
      document.dispatchEvent(new CustomEvent('grs:release-updated'));
    } catch (_) {
      // A failed refresh leaves the current page usable; Shopify checks inventory at checkout.
    } finally {
      refreshing = false;
    }
  }
  window.setInterval(refreshRelease, 30000);
  document.addEventListener('visibilitychange', refreshRelease);
})();
